export const Phone = {
  PhoneField: 'phone-field',
}